import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { mockRequest, uid } from '../utils/mock';
import type { AiFeedback } from '../models/ai.model';

export interface FeedbackSelection {
  text: string;
  left: number;
  top: number;
  width: number;
  height: number;
}

/**
 * Handles the RLHF (reinforcement learning from human feedback) flow.
 * Selection state is Angular state — the popover binds to it.
 */
@Injectable({ providedIn: 'root' })
export class AiFeedbackService {
  readonly selection = signal<FeedbackSelection | null>(null);
  readonly feedbacks = signal<AiFeedback[]>([]);

  setSelection(selection: FeedbackSelection): void {
    this.selection.set(selection);
  }

  clearSelection(): void {
    this.selection.set(null);
  }

  submitFeedback(feedback: Omit<AiFeedback, 'id' | 'submittedAt'>): Observable<void> {
    const record: AiFeedback = { ...feedback, id: uid('fb'), submittedAt: new Date() };
    this.feedbacks.update((list) => [record, ...list]);
    return mockRequest(undefined, 450);
  }
}
